export enum SessionBitMask {
  WasPerformanceDegraded = 0b00000001,
}

export const updateSessionBitMask = (bit: SessionBitMask): void => {
  sessionBitMask |= bit;
  console.log('sessionBitMask', sessionBitMask);
};

export let sessionBitMask = 0;
